const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);
const RECORD_BASE_ROOTS = ['therecordbase.com'];
const HOSTED_APP_SUFFIXES = ['.vercel.app', '.netlify.app', '.onrender.com', '.fly.dev'];
// Only single-label subdomains are eligible for a managed DistroGrid portal.
// Keep TRB-owned service hosts on the main application even when a DNS record exists.
const RESERVED_RECORD_BASE_SUBDOMAINS = new Set([
  'admin', 'api', 'b2b', 'distrogrid', 'portal', 'status', 'support', 'wl', 'www',
]);

export function normalizeHostname(hostname = '') {
  return String(hostname || '')
    .trim()
    .toLowerCase()
    .replace(/^\[/, '')
    .replace(/\]$/, '')
    .split(':')[0];
}

export function getCurrentHostname() {
  if (typeof window === 'undefined') return '';
  return normalizeHostname(window.location.hostname);
}

export function isLocalHostname(hostname = '') {
  const host = normalizeHostname(hostname);
  return !host || LOCAL_HOSTS.has(host);
}

export function isRecordBaseHostname(hostname = '') {
  const host = normalizeHostname(hostname);
  return RECORD_BASE_ROOTS.some((root) => host === root || host.endsWith(`.${root}`));
}

export function isPortalSubdomain(hostname = '') {
  return normalizeHostname(hostname).startsWith('portal.');
}

export function isManagedDistroGridPortalSubdomain(hostname = '') {
  const host = normalizeHostname(hostname);
  const suffix = '.therecordbase.com';
  if (!host.endsWith(suffix)) return false;

  const label = host.slice(0, -suffix.length);
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label)
    && !RESERVED_RECORD_BASE_SUBDOMAINS.has(label);
}

export function isHostedPreviewHostname(hostname = '') {
  const host = normalizeHostname(hostname);
  return HOSTED_APP_SUFFIXES.some((suffix) => host.endsWith(suffix));
}

export function shouldLookupWhiteLabelPortalByHost(hostname = '') {
  const host = normalizeHostname(hostname);
  if (!host || isLocalHostname(host)) return false;
  if (isPortalSubdomain(host) || isManagedDistroGridPortalSubdomain(host)) return true;
  if (isRecordBaseHostname(host) || isHostedPreviewHostname(host)) return false;
  return host.includes('.');
}

export function buildPortalSignupUrl(hostname = '') {
  const host = normalizeHostname(hostname);
  return host ? `https://${host}/signup` : '';
}
